import { createMuiTheme } from '@material-ui/core/styles';

export const theme = createMuiTheme({
  typography: {
    h4: {
      fontFamily: "'PT Serif', serif",
      fontWeight: 700,
      paddingTop: 16
    },
    h6: {
      fontFamily: "'PT Serif', serif",
      fontWeight: 700,
      paddingTop: 16
    }
  }
})
